export const GET_ASSESSMENTS_REQUEST = "GET_ASSESSMENTS_REQUEST";
export const GET_ASSESSMENTS_SUCCESS = "GET_ASSESSMENTS_SUCCESS";
export const GET_ASSESSMENTS_FAIL = "GET_ASSESSMENTS_FAIL";

export const ASSESSMENT_REQUEST = "ASSESSMENT_REQUEST";
export const ASSESSMENT_SUCCESS = "ASSESSMENT_SUCCESS";
export const ASSESSMENT_FAIL = "ASSESSMENT_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
